import React, { useState } from 'react'
import { Col, Row, Spinner } from 'react-bootstrap'
import { authAxios } from '../../../API/apiRequest'
import { TextArea } from '../../../components/TextArea/TextArea'
import TextField from '../../../components/TextField/TextField'
import { EmployerLayout } from '../Layout/EmployerLayout'
import classes from './Report.module.css'

const Report: React.FC = ()=>{
   
    const [loading, setLoading] = useState<boolean>(false)
    const [title, setTitle] = useState<string>('')
    const [responseText, setResponseText] = useState<string>('')
    const [errText, setErrText] = useState<string>('')
    const [msg, setMsg] = useState<string>('')


    const sendData = async()=>{
        try{
            if(!title || !msg) return setErrText('من فضلك تأكد من إدخال العنوان والرسالة')
            if(msg.length > 200 || title.length > 70) return setErrText('برجاء ادخال الرسالة بحد اقصي 200 حرف والعنوان 70 حرف')
            setLoading(true)
            let response = await authAxios.post('/report', {message: msg, title})
            if(response.status === 201){
                setResponseText('تم إرسال رسالتك')
                setMsg('')
                setTitle('')
                setLoading(false)
                return
            }
            setMsg('')
            setTitle('')
            setLoading(false)
            return
        }catch(e){
            setErrText('حدث خطأ اثناء الإرسال من فضلك حاول مرة اخري')
            setLoading(false)
            console.log(e)
        }
    }

    return(
        <EmployerLayout>
            <Row>
                <Col>
                  <p style={{color: '#fff', textAlign: 'right', fontSize: 25}}>اقتراحات او الإبلاغ عن مشكلة</p>
                </Col>
            </Row>
            <Row>
                <Col style={{display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end', marginBottom: 20}}>
                <TextField
                  placeholder='العنوان'
                  handleChange={({target})=>{setErrText(''); setTitle(target.value)}}
                  value={title}
                />
                </Col>
            </Row>
            <Row>
            <Col style={{display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end'}}>
                <TextArea
                  placeholder='الرسالة'
                  handleChange={({target})=>{setErrText('');  setMsg(target.value);}}
                  value={msg}
                />
            </Col>
            </Row>
            <Row>
                <p style={{color: 'tomato', fontSize: 16, textAlign: 'center', padding: 0, margin: 0, marginTop: 10}}>{errText}</p>
                <p style={{color: 'rgb(10,230,10)', fontSize: 16, textAlign: 'center', padding: 0, margin: 0, marginTop: 10}}>{responseText}</p>
                <Col style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                  <div className={classes.btn} onClick={loading ? ()=>{} : sendData}>
                    {loading ?  <Spinner color='#fff' animation='border' style={{backgroundColor: '#bbb', fontSize: 10}} size={'sm'}/> : <p style={{color: '#fff', fontSize: 14}}>إرسال</p>}
                  </div>
                </Col>
            </Row>
        </EmployerLayout>
    )
}

export default Report